// @flow
import React, { Component } from 'react';
import unescape from 'lodash/unescape';

type Props = {
    content: string,
};

export default class Html extends Component<Props> {
    render() {
        return (
            <div
                dangerouslySetInnerHTML={{
                    __html: unescape(this.props.content),
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/containers/Asset/ContentInjectors/Html/index.js